export const environment = {
  ANGULAR_API_URL: 'https://api-dev.qmractest.com/',
  ANGULAR_DEFAULT_PLACEHOLDER: '/images/default-placeholder.png',
  ANGULAR_OTP_TIME: 10, //seconds,
  ANGULAR_OTP_TIMER_VALUE: '00:10',
  ANGULAR_DATE_FORMAT: 'DD, MMMM YYYY',
  ANGULAR_DATE_MONTH_FORMAT: 'DD MMMM',
  ANGULAR_DATE_FORMAT_TABLE: 'MMM d, y',
  ANGULAR_SUPPORT_EMAIL: 'info@qmrac.com',
  ANGULAR_SUPPORT_PHONE: '+97433088426',
  ANGULAR_PHONE_SHOW: '+974-800-4527',
  ANGULAR_SECRET_KEY: 'dev-secret-key-1234567890',
  ANGULAR_REDIRECT_URL: 'https://customer-dev.qmractest.com',
};
